<app-toolbar class="toolbar">
  <button mat-raised-button 
          color="primary"
          matTooltip="Save" 
          class="toolbar-btn toolbar-btn--primary"
          [disabled]="form.invalid || form.pristine" 
          (click)="save()">
    <mat-icon svgIcon="save" />
    <span>Save</span>
  </button>

  <button mat-stroked-button 
          matTooltip="Save and Close" 
          class="toolbar-btn toolbar-btn--secondary"
          [disabled]="form.invalid || form.pristine" 
          (click)="saveAndClose()">
    <mat-icon svgIcon="save" />
    <span>Save and Close</span>
  </button>

  <div class="toolbar-separator"></div>

  @if (enableChangeDueDate()) {
  <button mat-stroked-button 
          matTooltip="Change Due Date"
          class="toolbar-btn toolbar-btn--secondary"
          (click)="changeDueDate()">
    <mat-icon>event</mat-icon>
    <span>Change Due Date</span>
  </button>
  }
  @if (enableComplete() || isCompleteActive) {
  <button mat-raised-button 
          matTooltip="Complete Action Item"
          class="toolbar-btn toolbar-btn--success"
          [disabled]="progressStatus() === 'INVALID'"
          (click)="confirmAIcomplete()">
    <mat-icon>check_circle</mat-icon>
    <span>Complete</span>
  </button>
  }
</app-toolbar>


<div class="container-fluid custom-header">
  <div class="header-top-row">
    <div class="header-title-section">
      <h1 class="header-main-title">{{ form.get('actionItemId')?.value || title() }} </h1>
      <div class="header-entity-name">{{ title() }}</div>
    </div>
    <div class="header-info-section">
      <div class="info-block">
        <span class="info-value">{{ form.get('actionItemId')?.value }}</span>
        <span class="info-label">{{displayNames['actionItemId']}}</span>
      </div>

      <mat-divider [vertical]="true" />

      @if (reportOwner(); as reportOwner) {
        <div class="info-block">
          <span class="info-value info-value--accent">{{ reportOwner }}</span>
          <span class="info-label">{{displayNames['reportOwner']}}</span>
        </div>
        <mat-divider [vertical]="true" />
      }

      <div class="info-block">
        <span class="info-value">{{ form.get('status')?.value }}</span>
        <span class="info-label">{{displayNames['status']}}</span>
      </div>

      <mat-divider [vertical]="true" />

      <div class="info-block">
        <span class="info-value">{{ form.get('dueDate')?.value | date:'dd MMMM yyyy' }}</span>
        <span class="info-label">{{displayNames['dueDate']}}</span>
      </div>
    </div>
  </div>
</div>

<form class="create-form" [formGroup]="form">
  <div class="row">
    <div class="col-sm-12">
      <mat-card class="container-fluid">
        <mat-card-header>
          <mat-card-title class="section-title">Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">

            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Report</mat-label>
                <input matInput [value]="reportTitleEn() || ''" readonly (click)="navigateToReport()"
                  class="clickable-link">
              </mat-form-field>
            </div>

            <div class="col-md-3">
              <mat-form-field floatLabel="always">
                <mat-label>Progress</mat-label>
                <input matInput formControlName="progress" inputmode="numeric" autocomplete="off"
                  (keypress)="onProgressKeyPress($event)">
                <mat-error *ngIf="getErrorMessage('progress') as errorMessage">{{ errorMessage }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-3">

            </div>
            <div class="col-md-3">
              <mat-form-field>
                <mat-label>Report ID</mat-label>
                <input matInput [value]="uniqueId() || ''" readonly>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Status</mat-label>
                <input matInput [value]="reportStatus()||''" readonly>
              </mat-form-field>
            </div>

          </div>
        </mat-card-content>

      </mat-card>

      <mat-card class="container-fluid">
        <mat-card-header>
          <mat-card-title class="section-title">Action Item Details</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-sm-6">

              <div class="form-field">
                <label class="form-label">{{displayNames['actionItemId']}}</label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="actionItemId">
                </mat-form-field>
              </div>
              <div class="form-field ">
                <label class="form-label">{{displayNames["workScope"]}} <span class="required"></span></label>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="workScope">
                    <mat-option *ngFor="let option of workScopeOptions" [value]="option.value">{{option.label}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="getErrorMessage('workScope') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
              <div class="form-field">
                <label class="form-label">{{displayNames["actionType"]}} <span class="required"></span></label>
                <mat-form-field appearance="outline">
                  <mat-select formControlName="actionType">
                      <mat-option *ngFor="let option of actionTypeOptions"
                      [value]="option.value">{{option.label}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="getErrorMessage('actionType') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-field">
                <label class="form-label">
                  {{displayNames["actionItemOwner"]}} <span class="required"></span>
                  <mat-spinner *ngIf="loadingFields()['actionItemOwner']" diameter="11"></mat-spinner>
                </label>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="actionItemOwner"
                    [matAutocomplete]="actionItemOwnerAuto">
                  <mat-autocomplete #actionItemOwnerAuto="matAutocomplete"
                    (optionSelected)="onEmailAutocompleteSelected($event, 'actionItemOwner', 'ownerFullName')">
                    <mat-option *ngFor="let email of getEmailAutocompleteOptions('actionItemOwner')" [value]="email">
                      {{ email }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="getErrorMessage('actionItemOwner') as errorMessage">{{ errorMessage }}</mat-error>
                </mat-form-field>
              </div>


              <div class="form-field ">
                <mat-form-field appearance="outline">
                  <textarea matInput formControlName="ownerFullName" maxlength="2048" placeholder="Owner Full Name"
                    readonly></textarea>
                </mat-form-field>
              </div>

            </div>



          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="container-fluid">
        <mat-card-header>
          <mat-card-title class="section-title">Description</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="form-field">
            <label class="form-label">{{displayNames["actionItemDescriptionEn"]}} <span class="required"></span></label>
            <div class="control-col">
              <angular-editor [id]="'actionItemDescriptionEn'" formControlName="actionItemDescriptionEn" [config]="configEN"></angular-editor>
              <mat-error *ngIf="getErrorMessage('actionItemDescriptionEn') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
          <div class="form-field">
            <label class="form-label">{{displayNames["actionItemDescriptionRu"]}} </label>
            <div class="control-col">
              <angular-editor [id]="'actionItemDescriptionRu'" formControlName="actionItemDescriptionRu" [config]="configRU"></angular-editor>
              <mat-error *ngIf="getErrorMessage('actionItemDescriptionRu') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
          <div class="form-field">
            <label class="form-label">{{displayNames["actionItemDescriptionKz"]}} </label>
            <div class="control-col">
              <angular-editor [id]="'actionItemDescriptionKz'" formControlName="actionItemDescriptionKz" [config]="configKZ"></angular-editor>
              <mat-error *ngIf="getErrorMessage('actionItemDescriptionKz') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-field ">
              <label class="form-label">{{displayNames["dueDate"]}} <span class="required"></span></label>
              <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="picker" [max]="resolutionTargetDate()" (click)="picker.open()" formControlName="dueDate">
                @if (form.get('dueDate')?.value) {
                  <mat-icon class="clear-date" matDatepickerToggleIcon (click)="clearDate('dueDate')">clear</mat-icon>
                }
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="getErrorMessage('dueDate') as errorMessage">{{ errorMessage }}</mat-error>
              </mat-form-field>
            </div>
            <div class="form-field ">
              <label class="form-label">{{displayNames["createdOn"]}}</label>
              <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="picker1" (click)="picker1.open()" formControlName="createdOn"
                  [disabled]="isDisabled">
                @if (form.get('createdOn')?.value && form.get('createdOn')?.enabled) {
                  <mat-icon class="clear-date" matDatepickerToggleIcon (click)="clearDate('createdOn')">clear</mat-icon>
                }
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1 [disabled]="isDisabled"></mat-datepicker>
                <!-- <mat-error *ngIf="getErrorMessage('createdon') as errorMessage">{{ errorMessage }}</mat-error> -->
              </mat-form-field>
            </div>
            <div class="form-field ">
              <label class="form-label">{{displayNames["completedOn"]}}</label>
              <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="picker2" (click)="picker2.open()" formControlName="completedOn"
                  [disabled]="isDisabled">
                @if (form.get('completedOn')?.value && form.get('completedOn')?.enabled) {
                  <mat-icon class="clear-date" matDatepickerToggleIcon (click)="clearDate('completedOn')">clear</mat-icon>
                }
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2 [disabled]="isDisabled"></mat-datepicker>
                <!-- <mat-error *ngIf="getErrorMessage('completedon') as errorMessage">{{ errorMessage }}</mat-error> -->
              </mat-form-field>
            </div>

          </div>

        </mat-card-content>
      </mat-card>
    </div>

    <!-- <div class="col-sm-6 p-0">
      <mat-card>
        <mat-card-content>
          <app-timeline
            [timelineRecords]="timelineList"
            [haveAccess]="false"
            (createNote)="createNote()"
            (download)="download($event)"
          />
        </mat-card-content>
      </mat-card>
    </div> -->
  </div>

</form>
